export default "__VITE_ASSET__Dmy__L56__"